const CLASS_NAME = "withdrawal-link";

class CmsWithdrawalLink {
    private withdrawalLink: HTMLAnchorElement;

    constructor(withdrawalLink: HTMLAnchorElement) {
        this.withdrawalLink = withdrawalLink;
        this.addClassToWithdrawalLink();
    }

    private addClassToWithdrawalLink = () => {
        this.withdrawalLink.classList.add(CLASS_NAME);
    };
}

export default class CmsWithdrawalLinkHandler {
    public static init = () => {
        const footerLinks = document.querySelector(".footer-links");

        if (!footerLinks) {
            return;
        }

        const withdrawalLink = footerLinks.querySelector(
            'a[href="/withdrawal"]',
        ) as HTMLAnchorElement;

        if (withdrawalLink) {
            new CmsWithdrawalLink(withdrawalLink);
        }
    };
}
